import { isMobile } from '@ringcentral/rwc-utils/src/client-detection';
import {
    IN_MEETING,
    OUTSIDE_MEETING,
} from '@ringcentral/rwc-utils/src/constants/analytics-event-types';
import { withEndPoint } from '@rwc/utils/track-endpoint';
import { secureAnalytics } from '@ringcentral/rwc-utils/src/analytics/secure-analytics';

const createTrackFoo = key => (tapButton, action) => {
    if (!isMobile) return;

    secureAnalytics.track(key, withEndPoint({ action, tapButton }));
};

export const trackWelcomePage = createTrackFoo(OUTSIDE_MEETING.WELCOME_PAGE_CLICK);

export const trackJoinModal = createTrackFoo(OUTSIDE_MEETING.JOIN_MODAL_CLICK);

export const trackMeetingLinkPage = createTrackFoo(OUTSIDE_MEETING.MEETING_LINK_PAGE_CLICK);

export const trackUnSupportPage = createTrackFoo(OUTSIDE_MEETING.NOT_SUPPORT_PAGE_CLICK);

export const trackDialIn = createTrackFoo(IN_MEETING.JOIN_AUDIO);

export const trackRequireSignIn = createTrackFoo(OUTSIDE_MEETING.REQUIRE_SIGNIN_PAGE_CLICK);
